<template>
  <b-container class="page-container" style="background-color: #f0f0f0" fluid>
    <NextLevelWithoutDSCheckout :combos="combos" :variant="variant" />
  </b-container>
</template>
<style>
</style>

<script>
import NextLevelWithoutDSCheckout from "@/components/checkout/nextlevelspecial/NextLevelWithoutDSCheckout.vue";

export default {
  title: "Next Level Power Drops Program",
  name: "NextLevelWithoutDS",
  props: ["combos"],
  mounted: function() {
    let optimize = document.createElement("script");
    optimize.setAttribute("src",  "https://www.googleoptimize.com/optimize.js?id=OPT-WDWCDZ9");
    document.head.appendChild(optimize);
  },
  computed: {
    variant: function () {
      return 'A';
    },
  },
  components: {
    NextLevelWithoutDSCheckout,
  },
};
</script>
